export const createReducer =
  (initialState, functions) =>
  (state, action, ...rest) => {
    const { type, payload } = action;
    const handler = functions[type];
    const newState = state || initialState;

    return handler ? handler(newState, payload, ...rest) : newState;
  };
